const data = {};
//导航
//默认匹配焦点路由，第一个为点击时跳转路由
data.nav = {
    '首页': 'home',
    '关于我们': 'about',
    '产品展示': 'product,productDetail',
    '新闻中心': 'news,newsDetail',
    '技术服务': 'service',
    '人才招聘': 'employ',
    '联系我们': 'contact'
};
// 所有路由，用于左侧栏目匹配
data.route = {
    '首页': 'home',
    '关于我们': 'about',
    '产品展示': 'product',
    '新闻中心': 'news',
    '技术服务': 'service',
    '人才招聘': 'employ',
    '联系我们': 'contact',
    '资质荣誉': 'honor',
    '企业文化': 'culture',
    '网络销售': 'sale',
    '新闻详情': 'newsDetail',
    '产品详情': 'productDetail'
};

export default data;



// WEBPACK FOOTER //
// ./src/assets/js/data.js